/** App version — update this on every deploy */
export const APP_VERSION = '0.3.1';
